const cookieManager = {
	setCurrentMenu(val) {
		localStorage.setItem('currentMenuSelected', val);
	},
	getCurrentMenu() {
		//currentMenuSelected
		let value = localStorage.getItem('currentMenuSelected');
		return value;
	},
	getUser() {
		let value = localStorage.getItem('user');
		if (value != 'null') {
			return JSON.parse(value);
		} else {
			return null;
		}
	},
	//这里传入对象即可
	setUser(obj) {
		let temp = JSON.stringify(obj)
		localStorage.setItem('user', temp);
	},
	delUser(fn) {
		localStorage.removeItem('user');
		fn();
	},
	//检查权限，返回 true or false
	//val（要检查的权限项目）：1、新闻编辑；2、产业编辑；3、招聘编辑；4、账号管理；
	verifyPermissions(val) {
		let user = this.getUser();
		if (user != null) {
			let temp = user.userTypes.filter((item) => {
				return item.type == val
			});
			// console.log(temp, 'temp')
			if (temp.length > 0) {
				return true;
			}
		} else {
			return false;
		}
	}
}
export default cookieManager;



// WEBPACK FOOTER //
// ./src/utils/cookieManager.js